<div class="custom-mat-dialog-form"> <!-- TODO: (before migration) Angular 19: style="height:95%" -->
  <div>
    <h3>{{this.data?.MeasureId ? 'Update' : 'Create New'}} Measure</h3>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-12 form-group">
          <br />
          <mat-label> <span>Related KPI</span><span class="orange-asterisk">&nbsp;*</span></mat-label>
        </div>
        <div class="col-sm-12 form-group">

          <ng-select [items]="availableKpis"
            [searchable]="true"
            [clearable]="false"
            bindLabel="Name"
            bindValue="Id"
            formControlName="kpiDefinitionId" required>
          </ng-select>
          <br>

          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 form-group">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" required>
              </mat-form-field>

              @if (
                form.get('name')?.invalid &&
                (form.get('name')?.dirty ||
                form.get('name')?.touched)) {
                <p>
                  @if (form.get('name')?.hasError('required')) {
                    <mat-error>This field is required</mat-error>
                  }
                </p>
              }
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 form-group">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <input matInput formControlName="description" required>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 form-group">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Owner</mat-label>
                <input matInput formControlName="owner" required>
              </mat-form-field>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="panel-body">
            <button (click)="backButtonHandler($event)" mat-raised-button class="btn  button-color-fix_red ">
              <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
              Back
            </button>
            <button mat-raised-button type="submit" class="btn button-color-fix pull-right" [disabled]="!form.valid">
              {{buttonLabel}}
              <mat-icon class=" icon-color-fix ">{{buttonIcon}}</mat-icon>
            </button>

          </div>
        </div>
      </form>
    </div>
  </div>
